module.exports = __webpack_public_path__ + "static/media/sad-box.6803f388.png";